const CreateUser_mutate = `
    mutation createUser(
      $email: String!,
	  $password: String!,
      $repeatPassword: String!,
	  $username: String!) {
      createUser(
        email: $email,
		password: $password,
        repeatPassword: $repeatPassword,
		username: $username) {
        userId
		email
		password
        repeatPassword
		username
      }
    }
`;


module.exports = {
  CREATE_USER_MUTATION : CreateUser_mutate,
}
